module.exports = __webpack_public_path__ + "img/w3_logout_dark.047f534a.png";